/**
 * KlachtBanner — rode (of groene bij Opgelost) banner bovenin Layout.
 * Toont status van een actieve klacht en linkt naar KlachtView voor detail.
 *
 * Verberg bij status 'Gesloten' (klacht is afgelopen, banner irrelevant).
 * Bij 'Opgelost' wordt de banner groen — klant ziet dat het rond is, kan nog
 * even op detail klikken voor de tijdlijn.
 *
 * Brand voice: "uw" (formele klant-relatie Kleda), warm en empathisch.
 */

import { type ClientKlacht, KLACHT_STATUS_LABELS, isKlachtOpen } from '../lib/klacht-types'

interface Props {
  klacht: ClientKlacht
  onOpenDetail: () => void
}

export function KlachtBanner({ klacht, onOpenDetail }: Props) {
  if (!isKlachtOpen(klacht.status)) return null

  const isOpgelost = klacht.status === 'Opgelost'
  const bgClass = isOpgelost
    ? 'bg-emerald-600 hover:bg-emerald-700'
    : 'bg-red-600 hover:bg-red-700'
  const icon = isOpgelost ? '✓' : '⚠'

  return (
    <button
      type="button"
      onClick={onOpenDetail}
      className={`w-full text-left ${bgClass} text-white px-4 py-3 rounded-lg mb-4 shadow-md transition-colors`}
      aria-label={`Klacht ${klacht.klachtNummer} — ${KLACHT_STATUS_LABELS[klacht.status]}. Klik voor details.`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs font-semibold uppercase tracking-wide opacity-90">
            {icon} Klacht {klacht.klachtNummer}
          </div>
          <div className="text-base font-medium mt-0.5">
            {KLACHT_STATUS_LABELS[klacht.status]}
          </div>
        </div>
        <span className="text-sm underline whitespace-nowrap">
          Bekijk status →
        </span>
      </div>
    </button>
  )
}
